// extracted by mini-css-extract-plugin
module.exports = {"root":"BtnSubmit_root__1RswS"};